<template>
  <span>
    <div class="section section__how-learn" style="padding-bottom: 0;">
      <div class="section__wrapper">
        <div class="title-with-icon mb-4">
          <div class="title-with-icon__icon title-with-icon__icon_how-learn"></div>
          <div class="title-with-icon__title">Экспортный разбор</div>
        </div>
        <about-export-a/>
        <carousel
            :loop="true"
            :per-page="1"
            :pagination-enabled="false"
            :scroll-per-page="false"
            :navigation-enabled="true"
            :navigation-next-label="navigationNext"
            :navigation-prev-label="navigationPrev"
            ref="homeCarrousel"
            :per-page-custom="[[420, 1], [1024, 4]]"
            class="d-flex">
          <slide v-for="(item, index) in items" :key="index">
              <a
                  :href="`/pic/analysis/${item}`"
                  data-fancybox="gallery"
              >
                <div
                    class="ffg__carousel__item"
                    :style="{
                    backgroundSize: 'cover',
                    height: '40vh',
                    display: 'block',
                    backgroundImage: `url('/pic/analysis/${item}')`
                  }"
                />
              </a>
          </slide>
        </carousel>
      </div>
    </div>
    <page-footer/>
  </span>
</template>

<script>
import PageFooter from "@/components/PageFooter.vue";
import AboutExportA from "@/components/export-analysis/AboutExportA.vue";
import $ from 'jquery';

export default {
  name: "ExportAnalysis",
  components: {AboutExportA, PageFooter},
  data() {
    return {
      items: [
        '2024-10-14_13-49-25_NZ.jpg',
        '2024-10-14_13-53-19_NZ.jpg',
        '2024-10-14_13-54-17_NZ.jpg',
        '2024-10-14_15-05-45_NZ.jpg',
        '2024-10-14_15-06-10_NZ.jpg',
        '2024-10-14_15-08-05_NZ.jpg',
        '5230986394200042537.jpg',
        '5413405393406780669.jpg'
      ]
    }
  },
  mounted() {
    this.$parent.init()
    this.$nextTick(() => {
      if (window.$ && $.fancybox) {
        $('[data-fancybox="gallery"]').fancybox({
          loop: true,
          buttons: ['zoom', 'close'],
        });
      }
    });
  },
  computed: {
    navigationNext() {
      return '<svg width="45" height="36" viewBox="0 0 45 36" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M45.0001 18.018L26.4833 35.5212L22.807 32.0461L35.0503 20.4793L6.10352e-05 20.4793L6.10352e-05 15.5632L35.0503 15.5632L22.807 3.99638L26.4833 0.52124L45.0001 18.018Z" fill="#002E5E"/>\n' +
          '</svg>'
    },
    navigationPrev() {
      return '<svg width="45" height="36" viewBox="0 0 45 36" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M6.25648e-05 18.0244L18.5168 0.521238L22.1931 3.99638L9.94985 15.5632L45.0001 15.5632L45.0001 20.4793L9.94985 20.4793L22.1931 32.0461L18.5168 35.5212L6.25648e-05 18.0244Z" fill="#002E5E"/>\n' +
          '</svg>'
    }
  },
}
</script>

<style scoped>

</style>